
//import Masonry from 'masonry-layout'

export default {
  init() {
    /*const grid = document.querySelector('.contact-list');
    const msnry = new Masonry(grid, {
      itemSelector: '.contact-item',
      transitionDuration: 0,
      initLayout: false,
      fitWidth: true,
    });

    msnry.once('layoutComplete', () => {
      grid.classList.add('load')
    });

    msnry.layout();*/
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-contact.js